module.exports = __webpack_public_path__ + "img/university_20.563c4588.png";